module.exports = __webpack_public_path__ + "img/picto_ok.a310da2c.png";